module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        projectsControllerComponentClass: 'templates_office_projects_controller',
        projectTermsControllerComponentClass: 'templates_office_projectTerms_controller',
        buttonContext: 'projectTermJobs',
        showHead: true,
        tableHeadTitleKey: 'table.head.absenceProjectTermJobConflicts',
        showIDs: true,
        // showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {
            durations: true,
            advertisement: true,
            skills: true,
            infoInternal: true,
        },
        rowActionsInline: true,
        rowActionsProperties: {
            colWidth: '105px',
        },
        // rowActions: {
        //     edit: true,
        //     customs: [
        //         {
        //             buttonType: 'advertise',
        //         },
        //         {
        //             buttonType: 'delete',
        //             neutral: true,
        //         }
        //     ]
        // },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_jobs': true,
            'resourceChanged.bo_status': true,
            'resourceChanged.bo_employees': true,
            'resourceChanged.bo_projectTermJobs': true,
            'resourceChanged.bo_projectTermJobStatus': true,
        },
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'startTS',
                direction: 'asc'
            },{
                fieldCode: 'projectTermJobID',
                direction: 'asc'
            }]
        }
    },

    // events: {
    //     showProjectTermJobApplications: {
    //         type: 'mouseenter',
    //         selector: 'tbody td.fieldOf_advertisement',
    //         action: function(event){
    //             const self = event.data.component
    //             const controller = self.model.controller
    //             const $target = $(event.target).closest('tbody')
    //
    //             if(controller && $target.length > 0){
    //                 const rowID = $target.data('rowId')
    //                 const rowData = self.getRowData(rowID)
    //
    //                 if(rowID){
    //                     controller.showProjectTermJobApplications(rowID, rowData)
    //                 }
    //             }
    //         }
    //     },
    //
    //     hideProjectTermJobApplications: {
    //         type: 'mouseleave',
    //         selector: 'tbody td.fieldOf_advertisement',
    //         action: function(event){
    //             const self = event.data.component
    //             const controller = self.model.controller
    //             const $target = $(event.target).closest('tbody')
    //
    //             if(controller && $target.length > 0){
    //                 const rowID = $target.data('rowId')
    //                 const rowData = self.getRowData(rowID)
    //
    //                 if(rowID){
    //                     controller.hideProjectTermJobApplications(rowID, rowData)
    //                 }
    //             }
    //         }
    //     },
    // },

    methods: {
        // onPrepareDone(){
        //     this.config.customHeadActionsFormMapping = {
        //         buttons: [
        //             { buttonType: 'showInsert', context: this.config.buttonContext, positive: true }
        //         ]
        //     }
        // },

        // showInsert(buttonContext, buttonMode){
        //     this.locate('< templates_core_controller_controller > templates_office_projectTerms_propertiesForm', projectTermPropertiesForm => {
        //         const startTS = projectTermPropertiesForm.getFieldValue('startTS', 'live')
        //         const endTS = projectTermPropertiesForm.getFieldValue('endTS', 'live')
        //         this.model.controller.showInsert(buttonContext, buttonMode, {
        //             source: {
        //                 load: {
        //                     componentData: {
        //                         actions: {
        //                             loadContent: {
        //                                 source: {
        //                                     load: {
        //                                         componentData: {
        //                                             model: {
        //                                                 dirtyFields: {
        //                                                     data: {
        //                                                         attributes: {
        //                                                             startTS,
        //                                                             endTS
        //                                                         }
        //                                                     }
        //                                                 }
        //                                             }
        //                                         }
        //                                     }
        //                                 }
        //                             }
        //                         }
        //                     }
        //                 }
        //             }
        //         })
        //     })
        // },

        // async advertise(entityID, entityData){
        //     if(entityID){
        //         const isAdvertised = (entityData.attributes || {}).isAdvertised
        //
        //         if(isAdvertised){
        //             return this.performAction(
        //                 this.prepareAction('message', undefined, {
        //                     messageDisplay: {
        //                         message: 'error:advertiseProjectTermJob.alreadyDone'
        //                     }
        //                 })
        //             )
        //         } else {
        //             await this.performAction(this.prepareAction('edit_projectTermJob', entityID, undefined, {
        //                 source: {
        //                     submit: {
        //                         data: {
        //                             data: {
        //                                 attributes: {
        //                                     isAdvertised: true,
        //                                     isAdvertisedAt: new Date().toISOString()
        //                                 }
        //                             }
        //                         }
        //                     }
        //                 }
        //             }))
        //
        //             this.refreshData()
        //         }
        //     }
        // },

        async showEdit(rowID, rowData){
            const { projectID, projectTermID } = (rowData || {}).attributes || {}

            if(!projectID || !projectTermID) return;

            const projectsController = getComponent($(`.${this.config.projectsControllerComponentClass}`))
            if(!projectsController) return;

            const actionContext = await projectsController.showEdit('projects', projectID, {
                attributes: { projectID },
                primaryKey: 'projectID'
            })

            let projectTermsController
            actionContext.component.find(this.config.projectTermsControllerComponentClass, c => {
                const foundProjectID = ((((c.model || {}).parentEntity || {}).entityData || {}).attributes || {}).projectID
                if(projectID == foundProjectID){
                    projectTermsController = c
                    return 'break'
                }
            })

            if(!projectTermsController) return;
            return projectTermsController.showEdit('projectTerms', projectTermID, {
                attributes: { projectTermID },
                primaryKey: 'projectTermID'
            })
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey
            const baseFilters = (this.model.parentEntityForTable || {}).baseFilters || {}

            if(refreshers[key] && (
                (
                    key !== 'resourceChanged.bo_projectTermJobs' &&
                    key !== 'resourceChanged.bo_projectTermJobStatus' &&
                    key !== 'resourceChanged.bo_status'
                ) ||
                message.data.projectTermID == baseFilters.projectTermID ||
                (message.data.projectTermIDs || {})[baseFilters.projectTermID] ||
                (key === 'resourceChanged.bo_status' && this.isAtLeastOneStatusIDLoaded(message.data.statusIDs))
            )){
                this.delayedLastOf('refreshByHeartbeat', () => this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
            }
        },
    }
}